// extracted by mini-css-extract-plugin
export default {"image-item":"imageItem_image-item__9LXy7","image-item__operation":"imageItem_image-item__operation__b-4ZH"};